module.exports = __webpack_public_path__ + "static/media/lamp-floor.dd17f315.svg";